import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';

const AreaInput = (props) => {
  return(
    <Form.Item
      validateStatus={
      props.errors && props.errors.Area && props.touched.Area
        ? "error"
        : null
    }
      help={props.errors && props.touched.Area && props.errors.Area}
    >
      <h2 className="form-label">
        Area
      </h2>
      <Input 
        type="text" 
        id="Area" 
        className="form-input"
        value={props.values.Area} 
        onChange={props.onChange}
      />
    </Form.Item>
  );
}

AreaInput.propTypes = {
    onChange: () => {},
    errors: PropTypes.shape({
        Area: PropTypes.string,
    }),
    values: PropTypes.shape({
        Area: PropTypes.string,
    }),
    touched: PropTypes.shape({
        Area: PropTypes.bool,
    })
}

AreaInput.defaultProps = {
    onChange: () => {},
    errors: {},
    values: {},
    touched: {}
}

export default AreaInput;
